import { Component, OnInit, Input } from '@angular/core';
import { DocumentService } from '../../../shared/services/document/document.service';
import { ToasterService } from '../../../shared/services/toaster/toaster.service';
import { GetFilesForUserApiResponse } from '../../../shared/models/api.model';
import { DocumentQueryParams } from '../../../shared/services/document/document.service';
import { DocumentTypesService } from 'src/app/modules/shared/services/document-types/document-types.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {

  @Input() userId!: number;
  
  file_data: GetFilesForUserApiResponse = { documents: []};
  isLoading = true;
  search_query: string = '';
  show_filters = false;
  /* If the current result set is the result of a search */
  search_is_active = false;
  // Query parameters (server may support paging even if response doesn't include totals)
  currentPage = 1;
  pageSize = 10;
  // filters
  filter_fileType: number[] | undefined = undefined;
  filter_extension: string[] = [];

  constructor(
    private documentService: DocumentService,
    private documentTypesService: DocumentTypesService,
    private Toaster: ToasterService
  ) {}

  public toggleFilters() {
    this.show_filters = !this.show_filters;
  }

  public refreshFileList() {
    this.getFiles();
  }

  public async getFiles() {
    this.isLoading = true;
    this.search_is_active = !!this.search_query;

    try {
      if (this.userId === undefined || this.userId === null) {
        throw new Error('ListComponent requires a userId input');
      }

      const params: Partial<DocumentQueryParams> = {
        page: this.currentPage,
        pageSize: this.pageSize,
        search: this.search_query,
        fileType: this.filter_fileType,
        extension: this.filter_extension
      };

      const response = await this.documentService.listFilesByUser(this.userId, params);
      this.file_data = response;
    } catch (error: any) {
      this.Toaster.warning(`Error fetching files: ${error?.message ?? error}`, 4000);
      console.error('Error fetching files:', error);
    } finally {
      this.isLoading = false;
    }
  }

  public clearSearch() {
    this.search_query = '';
    this.onSearch();
  }

  // Add method to handle search
  public onSearch() {
    this.currentPage = 1; // Reset to first page when searching
    this.getFiles();
  }

  // Add method to handle page changes (if server paging is used)
  public onPageChange(page: number) {
    this.currentPage = page;
    this.getFiles();
  }

  /** Returns the sum total of all selected filters for
   * displaying to the user in the subnav
   */
  public sumOfFilterLength(): number {
    return (this.filter_fileType?.length?? 0) + (this.filter_extension?.length?? 0);
  }

  public onFilterTypeChange(type_id: number) {
    // If the type is already n the types array, remove it
    if (this.filter_fileType?.includes(type_id)) {
      this.filter_fileType = this.filter_fileType.filter((type) => type !== type_id);
    } else {
      // Otherwise, add it to the array
      if (!this.filter_fileType) {
        this.filter_fileType = [];
      }
      this.filter_fileType.push(type_id);
    }
    this.currentPage = 1; // Reset to first page when filtering
    this.getFiles();
  }

  public onFilterTypeClear() {
    this.filter_fileType = undefined;
    this.currentPage = 1; // Reset to first page when filtering
    this.getFiles();
  }

  async ngOnInit(): Promise<void> {
    if (this.userId === undefined || this.userId === null) {
      this.Toaster.warning('A userId is required to list files for a user.', 4000);
      console.error('ListComponent initialization error: userId is missing');
      return;
    }
    this.getFiles();
  }
}
